import { Sidebar } from "../Layout/Sidebar";
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const Tag = () => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const deleteItem = async (id: number) => {
    if(confirm('آیا مطمئن هستید؟')){
      dispatch(setLoading(true));

      const res = await restApi(process.env.REACT_APP_BASE_URL + '/admin/tag/' + id, true).delete({});

      if(res.code == 200){
        Swal.fire({
          title: 'موفق',
          text: 'تگ با موفقیت حذف شد',
          icon: 'success',
          confirmButtonText: 'متوجه شدم'
        })
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        })
      }

      dispatch(setLoading(false));
    }
  }

  const list = () => {
    const rows = [];

    data.filter((tag:any) => tag.title.toLowerCase().includes(query.toLowerCase())).map((tag: any, index) => {
      rows.push(
        <tr
          className={`dashTr2 ${index % 2 === 0 ? 'table-row-even' : 'table-row-odd'}`}
          key={`tag-${tag.id}-${index}`}
        >
          <td className="svgContainer">
            <i className="trash clickable" onClick={() => deleteItem(tag.id)}></i>
            <i className="edit clickable" onClick={() => navigate('/tag/edit/' + tag.id)}></i>
          </td>
          <td className="">{tag.createdAt}</td>
          <td className="">{tag.description}</td>
          <td className="">{tag.slug}</td>
          <td className="">{tag.title}</td>
          <td>{index + 1}</td>
        </tr>
      )
    })

    return rows;
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await restApi(process.env.REACT_APP_BASE_URL + '/admin/tag', true).get();
    console.log(res)
    if(res.code == 200){
      setData(res.data);
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return(

    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain">
        <h1 className="dashBoardTitle">لیست تگ ها</h1>
        <div className="searchContainer">
          <span className="dashboardHeader clickable" onClick={() => navigate('/tag/add')}>
            <p>افزودن تگ جدید</p>
            <i className="addPlus"></i>
          </span>
          <div className="dashboardseaechBox">
            <i className="dashMagnifierIcon"></i>
            <input className="dashSearchInput" placeholder="جستجو" onChange={(input: any) => setQuery(input.target.value)}></input>
          </div>
        </div>
        <table className="alternating-table listTable">
          <thead>
          <tr className="dashTr1 firstTR">
            <th>عملیات</th>
            <th>تاریخ ساخت</th>
            <th>توضیحات</th>
            <th>اسلاگ</th>
            <th>عنوان</th>
            <th>ردیف</th>
          </tr>
          </thead>
          <tbody>
          {list()}
          </tbody>
        </table>
      </main>
      </body>
    </>
  )
}
export default Tag;